import { cn } from '@spiaggeit/spit-ui'
import { Icon } from '@/assets/icons'

interface Props {
  label: string
  index: number
  activeStepIndex: number
}

export const Step = (props: Props) => {
  const { index, label, activeStepIndex } = props
  const isActive = index === activeStepIndex
  const isDone = index < activeStepIndex

  return (
    <div className="relative">
      <div
        className={cn('size-5 rounded-circle border', {
          'border-yellow-300 bg-yellow-300 p-px text-white': isDone,
          'border-yellow-300 bg-yellow-300 shadow-[inset_0_0_0_4.5px_var(--white)]':
            isActive,
        })}
      >
        {isDone ? <Icon className="size-4" name="ApproveTick" /> : null}
      </div>

      <div
        className={cn(
          'absolute left-1/2 -translate-x-1/2 text-nowrap p-1 text-xs text-secondary',
          { 'font-bold': isActive }
        )}
      >
        {label}
      </div>
    </div>
  )
}
